import React, { useState, useEffect } from 'react'
import cascading from '../assests/css/all.module.css';
import { Button, ButtonGroup } from 'react-bootstrap';
import { BiRightArrowAlt } from "react-icons/bi";
import { useSelector } from 'react-redux';

//lib
import { toFixedNumber } from '../lib/toFixedOf'
import { getWalletAddress } from '../lib/localStorage'
import { Duration } from '../lib/DateTimeHelper';

//hooks
import { ApproveToken, CheckIsApproved } from '../hooks/useNativeToken';
import { consolelog } from '../lib/consolelog';
import { getXAddress, ConvertToken, getXtokenInfo, RedeemToken, GetTokenOut, getXtokenusage } from '../hooks/useXtoken';
import { isEmpty } from '../lib/isEmpty';

//modals
import ComingSoonmodal from '../modals/comingSoonmodal';



export default function Approvecard(props) {

    // const [duration, setDuration] = useState([{
    //     time: "1M"
    // },
    // {
    //     time: "2M"
    // },
    // {
    //     time: "3M"
    // },
    // {
    //     time: "4M"
    // },
    // {
    //     time: "5M"
    // },
    // {
    //     time: "6M"
    // }])

    //selector 
    const { nativebalance, xtokenbalance } = useSelector((state) => state.wallet)

    //state 
    const [convertAmount, setConvertAmount] = useState('0')
    const [redeemAmount, SetredeemAmount] = useState('0')
    const [approve, setApprove] = useState(false)
    const [btnenable, setBtnenable] = useState(true);
    const [selecttab, setSelecttab] = useState(true);
    const [activebtn, setActivebtn] = useState(0)
    const [duration, setDuration] = useState(0)
    const [redeePercent, setredeePercent] = useState('0')
    const [XtokenDetail, setXtokenDetail] = useState({})
    const [incDisable, setincDisable] = useState(false)
    const [DecDisable, setDecDisable] = useState(false)
    const [days, Setdays] = useState('0')
    const [months, Setmonths] = useState('0')
    const [OutPut, setOutPut] = useState(0)
    const [modalcoming, setmodalcoming] = useState(false);


    //useEffect
    useEffect(() => {
        fetchDatas()

    }, [])
    useEffect(() => {
        getOutput()
    }, [redeemAmount, duration])
    //get function
    const fetchDatas = async () => {
        try {
            let XtokenDetails = await getXtokenInfo()
            if (!isEmpty(XtokenDetails)) {
                setXtokenDetail(XtokenDetails)
                setredeePercent(XtokenDetails.minRedeemRatio)
                setDecDisable(true)
                Setdays(Duration(XtokenDetails.minRedeemDuration, 'days'))
                Setmonths(Duration(XtokenDetails.minRedeemDuration, 'months'))
                setDuration(XtokenDetails.minRedeemDuration)
            }
            consolelog('XtokenDetails', XtokenDetails, true)
        } catch (err) {
            consolelog('fetchDatas__err', err, true)
        }

    }

    const getOutput = async () => {
        try {
            let amount = toFixedNumber(redeemAmount * 10 ** 18).toString()
            let Durations = duration
            let account = getWalletAddress()
            let outAmount = await GetTokenOut(amount, Durations, account)
            let percen = (outAmount * 100) / redeemAmount
            setOutPut(outAmount)
            if (!isNaN(percen)) {
                setredeePercent(parseFloat(percen).toFixed(0))
            }
        } catch (err) {
            consolelog('getOutput__err', err, true)
        }
    }

    const percentCal = (val) => {
        return parseFloat(val) / 100
    }

    //OnChange
    const handelchange = (e) => {
        try {
            const { value, id } = e.target

            var numbers = /^\d+((.)|(.\d{0,4})?)$/;
            if (!numbers.test(value) && value !== "") {

                return false;
            }
            if (id == 'convertAmount') {
                setConvertAmount(value)
            }
            if (id == 'redeemAmount') {
                SetredeemAmount(value)
            }
            if (id == 'months') {
                if (value == '') {
                    Setmonths('')
                    return
                }
                let seconds = value * 2628000
                let days = Duration(seconds, 'days')
                let months = Duration(seconds, 'months')
                days = days % 30
                Setdays(days)
                Setmonths(months)
                setDuration(seconds)
            }
            if (id == 'days') {
                if (value == '') {
                    Setdays('')
                    return
                }
                consolelog('handelchange', { value, id }, true)
                let seconds = parseFloat(value) * 86400
                let days = Duration(seconds, 'days')
                days = days % 30
                if (parseFloat(value) >= 30) {
                    let months = Duration(seconds, 'months')
                    Setmonths(months)
                }


                Setdays(days)

                setDuration(seconds)
            }

            if (e.target.value.length > 0) {
                setBtnenable(false)
            }
            else {
                setBtnenable(true)
            }
        } catch (err) {
            consolelog("handelchange__err", err, true)
        }
    }

    const inCreaseDuration = () => {
        try {
            let Time = duration
            let interval = 1 * 86400
            Time = Time + interval
            if (!(Time > XtokenDetail.maxRedeemDuration)) {
                if (Time == XtokenDetail.maxRedeemDuration) {
                    setincDisable(true)
                }
                let days = Duration(Time, 'days')
                days = days % 30
                if (days == 0) {
                    Setmonths(parseFloat(months) + 1)
                    Setdays(0)
                }
                else {
                    Setdays(parseFloat(days) + 1)
                }
                setDecDisable(false)
                setDuration(Time)
            }

        } catch (err) {
            consolelog('inCreaseDuration__err', err, true)
        }
    }

    const DeCreaseDuration = () => {
        try {
            let Time = duration
            let interval = 1 * 86400
            Time = Time - interval
            if (!(Time < XtokenDetail.minRedeemDuration)) {
                if (Time == XtokenDetail.minRedeemDuration) {
                    setDecDisable(true)
                }
                let Days = Duration(duration, 'days')
                Days = Days % 30
                if (Days == 0) {
                    Setmonths(parseFloat(months) - 1)
                    Setdays(29)
                }
                else {
                    Setdays(parseFloat(Days) - 1)
                }
                setincDisable(false)
                setDuration(Time)
            }
        } catch (err) {
            consolelog('DeCreaseDuration__err', err, true)
        }
    }

    const maxRedeemDuration = () => {
        try {
            let months = Duration(XtokenDetail.maxRedeemDuration, 'months')
            let days = Duration(XtokenDetail.maxRedeemDuration, 'days')
            days = days % 30
            Setdays(days)
            Setmonths(months)
            setDuration(XtokenDetail.maxRedeemDuration)

        } catch (err) {
            consolelog('maxRedeemDuration__err', err, true)
        }
    }

    //submit function
    const ApproveCall = async (e) => {
        try {
            let spenderAddress = getXAddress()
            let amount = toFixedNumber(parseFloat(convertAmount) * 10 ** 18).toString()
            let account = getWalletAddress()
            let isApproved = await CheckIsApproved(spenderAddress, amount, account)
            if (isApproved) {
                setApprove(true)
                return true
            }
            let approve = await ApproveToken(spenderAddress, amount, account)
            if (approve) {
                setApprove(true)
            }
        } catch (err) {
            consolelog("Approvefunc__err", err, true)
        }
    }

    const ConvertCall = async () => {
        try {
            let amount = toFixedNumber(parseFloat(convertAmount) * 10 ** 18).toString()
            let account = getWalletAddress()
            let approve = await ConvertToken(amount, account)
            if (approve) {
                setApprove(true)
            }
        } catch (err) {
            consolelog("ConvertCall__err", err, true)
        }
    }

    const RedeemCall = async () => {
        try {
            let amount = toFixedNumber(parseFloat(redeemAmount) * 10 ** 18).toString()
            let account = getWalletAddress()
            let Duration = duration
            let redeem = await RedeemToken(amount, Duration, account)
            consolelog('RedeemCall', redeem, true)
        } catch (err) {
            consolelog('RedeemCall__err', err, true)
        }
    }
    return (
        <div className={`${cascading.approvecard} mb-4`}>
            <div className={`${cascading.toptab}`}>
                <div onClick={() => setSelecttab(true)} className={selecttab ? `${cascading.tabsec} ${cascading.activetab} col-6` : `${cascading.tabsec} col-6`}>
                    <p className={`${cascading.tabname}`}>Convert</p>
                </div>
                <div onClick={() => setSelecttab(false)} className={!selecttab ? `${cascading.tabsec} ${cascading.activetab} col-6` : `${cascading.tabsec} col-6`}>
                    <p className={`${cascading.tabname}`}>Redeem</p>
                </div>
            </div>
            <div className={`${cascading.innercard}`}>
                <p className={`${cascading.head}`}>
                    {selecttab ? "Get YUM" : "Redeem YUM"}
                </p>
                <p className={`${cascading.desc}`}>
                    {selecttab ?
                        "Unlock bonus rewards and exclusive benefits by converting your DSP to YUM." :
                        `Redeem your YUM back into YUM over a vesting period of ${Duration(XtokenDetail.minRedeemDuration, 'days')} days (1: ${percentCal(XtokenDetail.minRedeemRatio)} ratio) to ${Duration(XtokenDetail.maxRedeemDuration, 'months')} months (1 :  ${percentCal(XtokenDetail.maxRedeemRatio)} ratio).`}
                </p>
                <div className={`${cascading.inputsec} my-3`}>
                    <div className={`input-group mb-3`}>
                        <input
                            type="text"
                            autoComplete={"off"}
                            className={`form-control`}
                            id={selecttab ? 'convertAmount' : 'redeemAmount'}
                            placeholder="0"
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            value={selecttab ? convertAmount : redeemAmount}
                            onChange={handelchange}
                        />
                        <div className={`input-group-append`} >
                            <button className={` ${cascading.inputspan}`} id="basic-addon1"
                                onClick={() => {
                                    if (selecttab) {
                                        setConvertAmount(nativebalance)
                                        setBtnenable(false)
                                    } else {
                                        SetredeemAmount(xtokenbalance)
                                        setBtnenable(false)
                                    }
                                }}>
                                Max
                            </button>
                        </div>
                    </div>
                    <p className={`${cascading.balsec}`}>{selecttab ? `balance : ${nativebalance} DSP` : `Wallet balance : ${xtokenbalance} YUM`}</p>
                </div>
                {selecttab == false &&
                    <>
                        <div className={`${cascading.redmsec}`}>
                            <div className="">
                                <p className={`${cascading.redmlabel}`}>Redeem duration</p>
                                <p className={`${cascading.redmbtn}`} onClick={() => { maxRedeemDuration() }}>Max</p>

                            </div>
                            <div className={`${cascading.grpbtnsec}`}>
                                {/* <input className="selectcount themeselect  w-full"
                                type='text'
                                name="tpPip"
                                min='0'
                                value={tpPip}
                                onChange={handleChange}
                            /> */}
                                {/* <div className='input-group-append font_sm_ap' onClick={() => { increasetpPip('takeprofit') }}>
                                <i className='fa fa-plus' />
                            </div>
                            <div className='input-group-append font_sm_ap' onClick={() => { decreasetpPip('takeprofit') }}>
                                <i className='fa fa-minus' />
                            </div> */}


                                <div className={`${cascading.inputsec}`}>
                                    <Button variant="secondary" id={'0'} disabled={DecDisable} onClick={() => { DeCreaseDuration() }}>-</Button>
                                    <div className={`${cascading.inpt_rows}`}>
                                        <p>Months</p>
                                        <input className="selectcount themeselect  w-full" autoComplete={"off"} type='text' id='months' value={months} onChange={handelchange} />
                                    </div>
                                    <div className={`${cascading.inpt_rows}`}>
                                        <p>Days</p>
                                        <input className="selectcount themeselect  w-full" autoComplete={"off"} type='text' id='days' value={days} onChange={handelchange} />
                                    </div>
                                    <Button variant="secondary" disabled={incDisable} id={'0'} onClick={() => { inCreaseDuration() }}>+</Button>
                                </div>



                                {/* <ButtonGroup aria-label="Basic example">
                                {duration.map((e, i) => (
                                    <Button variant="secondary" className={activebtn == i ? `${cascading.activebtn}` : ""} id={i} onClick={() => setActivebtn(i)}>{e.time}</Button>
                                ))}

                            </ButtonGroup> */}
                            </div>

                        </div>
                        <div className={`${cascading.listsec}`}>
                            <div className={`${cascading.listrow}`}>
                                <p>Redeem Ratio</p>
                                <p>{redeePercent}%</p>
                            </div>
                            <div className={`${cascading.listrow}`}>
                                <p>DSP output</p>
                                <p>{OutPut} DSP</p>
                            </div>
                        </div>
                    </>
                }


                <div className={`${cascading.btnsec}`}>
                    {selecttab ?
                        // <button
                        //     disabled={btnenable}
                        //     className={`btn ${cascading.btn}`}
                        //     onClick={() => {
                        //         if (!approve) {
                        //             ApproveCall()
                        //         } else {
                        //             ConvertCall()
                        //         }
                        //     }}
                        // >
                        //     {approve ? "CONVERT" : "APPROVE"}
                        // </button>

                        <button
                            className={`btn ${cascading.btn}`}
                            onClick={() => {
                                setmodalcoming(true)
                            }}
                        >
                            {approve ? "CONVERT" : "APPROVE"}
                        </button> :
                        // <button
                        //     disabled={btnenable}
                        //     className={`btn ${cascading.btn}`}
                        //     onClick={()=>{RedeemCall()}}
                        // >
                        //     REDEEM
                        // </button>
                        <button
                            className={`btn ${cascading.btn}`}
                            onClick={() => { setmodalcoming(true) }}
                        >
                            REDEEM
                        </button>
                    }
                    {/* <button 
                    disabled={btnenable} 
                    className={`btn ${cascading.btn}`}
                    >{selecttab ? "APPROVE" : "REDEEM"}</button> */}
                </div>
            </div>
            {modalcoming && <ComingSoonmodal show={modalcoming} onHide={() => { setmodalcoming(false); }} />}
        </div>

    )


}



